// extracted by mini-css-extract-plugin
export var table = "_yq-0";